import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-24 relative z-10">
      <div className="max-w-7xl mx-auto px-6 py-14 grid sm:grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        <div>
          <div className="flex items-center gap-2 font-display font-black text-base mb-3">
            <Zap className="text-[#39FF14] fill-[#39FF14]" size={18} /> ReactionLab
          </div>
          <p className="text-white/40 leading-relaxed">The reaction-performance playground. Test. Compete. Improve. Challenge. Repeat.</p>
        </div>
        <div>
          <div className="text-white/80 font-semibold mb-3">Product</div>
          <ul className="space-y-2 text-white/45">
            <li><Link to="/tests" className="hover:text-[#39FF14]">Reaction Tests</Link></li>
            <li><Link to="/games" className="hover:text-[#39FF14]">Reaction Games</Link></li>
            <li><Link to="/gaming" className="hover:text-[#39FF14]">For Gamers</Link></li>
            <li><Link to="/education" className="hover:text-[#39FF14]">For Educators</Link></li>
            <li><Link to="/brain" className="hover:text-[#39FF14]">Brain Games</Link></li>
            <li><Link to="/leaderboard" className="hover:text-[#39FF14]">Leaderboard</Link></li>
            <li><Link to="/speed-tests" className="hover:text-[#39FF14]">Speed Tests</Link></li>
            <li><Link to="/statistics" className="hover:text-[#39FF14]">Statistics</Link></li>
            <li><Link to="/daily" className="hover:text-[#39FF14]">Daily Challenge</Link></li>
            <li><Link to="/dashboard" className="hover:text-[#39FF14]">Dashboard</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white/80 font-semibold mb-3">Learn</div>
          <ul className="space-y-2 text-white/45">
            <li><Link to="/guides" className="hover:text-[#39FF14]">Guides</Link></li>
            <li><Link to="/guides/average-reaction-time" className="hover:text-[#39FF14]">Average Reaction Time</Link></li>
            <li><Link to="/guides/reaction-time-by-age" className="hover:text-[#39FF14]">Reaction Time by Age</Link></li>
            <li><Link to="/guides/how-to-improve-reaction-time" className="hover:text-[#39FF14]">How to Improve</Link></li>
            <li><Link to="/aim-trainer" className="hover:text-[#39FF14]">Aim Trainer</Link></li>
            <li><Link to="/methodology" className="hover:text-[#39FF14]">Methodology</Link></li>
            <li><Link to="/reaction-time-test" className="hover:text-[#39FF14]">Reaction Time Test</Link></li>
            <li><Link to="/f1-reaction-test" className="hover:text-[#39FF14]">F1 Reaction Test</Link></li>
            <li><Link to="/quick-draw-game" className="hover:text-[#39FF14]">Quick Draw Game</Link></li>
            <li><Link to="/rhythm-memory-game" className="hover:text-[#39FF14]">Rhythm Memory Game</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white/80 font-semibold mb-3">Company</div>
          <ul className="space-y-2 text-white/45">
            <li><Link to="/embed" className="hover:text-[#39FF14]" data-testid="footer-embed-link">Free Widgets</Link></li>
            <li><Link to="/privacy" className="hover:text-[#39FF14]">Privacy</Link></li>
            <li><Link to="/methodology" className="hover:text-[#39FF14]">How it works</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-white/30 text-xs">
        Browser-based reaction performance test. Not a medical, neurological, or intelligence assessment. © {new Date().getFullYear()} ReactionLab.
      </div>
    </footer>
  );
}
